module.exports = __webpack_public_path__ + "static/media/page-title-bg.fc1ff722.png";